import React, { useState } from 'react';
import {
  Table, TableRow, TableCell, TableHead, TableBody, Divider, Typography, Avatar,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useEffectAsync } from '../reactHelper';
import { useTranslation } from '../common/components/LocalizationProvider';
import { formatBoolean } from '../common/util/formatter';
import { prefixString } from '../common/util/stringUtils';
import PageLayout from '../common/components/PageLayout';
import SettingsMenu from './components/SettingsMenu';
import CollectionFab from './components/CollectionFab';
import CollectionActions from './components/CollectionActions';
import TableShimmer from '../common/components/TableShimmer';
import SearchHeader, { filterByKeyword } from './components/SearchHeader';
import { useRestriction } from '../common/util/permissions';

const useStyles = makeStyles((theme) => ({
  columnAction: {
    width: '1%',
    paddingRight: theme.spacing(1),
  },
  header1: {
    display: 'flex',
    margin: 20,
  },
  text: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  avatar: {
    display: 'flex',
    alignItems: 'center',
  },
  header2: {
    position: 'sticky',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginRight: 15,
    padding: 10,
  },
}));

const CommandsPage = () => {
  const classes = useStyles();
  const t = useTranslation();

  const [timestamp, setTimestamp] = useState(Date.now());
  const [items, setItems] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [loading, setLoading] = useState(false);
  const limitCommands = useRestriction('limitCommands');

  const commandsCount = (users) => items.filter(filterByKeyword(searchKeyword)).map((item) => item.name === users).length;

  useEffectAsync(async () => {
    setLoading(true);
    try {
      const response = await fetch('/api/commands');
      if (response.ok) {
        setItems(await response.json());
      } else {
        throw Error(await response.text());
      }
    } finally {
      setLoading(false);
    }
  }, [timestamp]);

  return (
    <PageLayout menu={<SettingsMenu />} breadcrumbs={['settingsTitle', 'sharedSavedCommands']}>
      <Divider />
      <div className={classes.header1}>
        <Typography sx={{ color: '#2b3643' }} className={classes.text} variant="h6">COMANDOS PERSONALIZADOS</Typography>
        <CollectionFab editPath="/settings/command" disabled={limitCommands} />
      </div>
      <div className={classes.header2}>
        <div className={classes.avatar}>
          <Avatar sx={{ width: 50, height: 30, borderRadius: 5, marginLeft: 0.5, marginRight: 1, color: 'white', backgroundColor: 'green' }}>{`${commandsCount('commands')}`}</Avatar>
          <SearchHeader keyword={searchKeyword} setKeyword={setSearchKeyword} />
        </div>
      </div>
      <Divider />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('sharedDescription')}</TableCell>
            <TableCell>{t('sharedType')}</TableCell>
            <TableCell>{t('commandSendSms')}</TableCell>
            {!limitCommands && <TableCell className={classes.columnAction} />}
          </TableRow>
        </TableHead>
        <TableBody>
          {!loading ? items.filter(filterByKeyword(searchKeyword)).map((item) => (
            <TableRow key={item.id}>
              <TableCell>{item.description}</TableCell>
              <TableCell>{t(prefixString('command', item.type))}</TableCell>
              <TableCell>{formatBoolean(item.textChannel, t)}</TableCell>
              {!limitCommands && (
                <TableCell className={classes.columnAction} padding="none">
                  <CollectionActions itemId={item.id} editPath="/settings/command" endpoint="commands" setTimestamp={setTimestamp} />
                </TableCell>
              )}
            </TableRow>
          )) : (<TableShimmer columns={limitCommands ? 3 : 4} endAction />)}
        </TableBody>
      </Table>
    </PageLayout>
  );
};

export default CommandsPage;
